module.exports = __webpack_public_path__ + "static/media/login_background.11df2e59.png";